/* Mialica shipping promo (13 Oct 2026)
   Pages can be served from cache, so this hides the promo once its end time has passed
   (top bar goes back to its usual message) and fills the "days left" label in Rome time. */
(function () {
  'use strict';

  var dayFmt = null;
  try {
    dayFmt = new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Rome', year: 'numeric', month: '2-digit', day: '2-digit' });
  } catch (e) {
    dayFmt = null;
  }

  function dayStart(ms) {
    var key;
    if (dayFmt && dayFmt.formatToParts) {
      var parts = {};
      dayFmt.formatToParts(new Date(ms)).forEach(function (p) { parts[p.type] = p.value; });
      key = parts.year + '-' + parts.month + '-' + parts.day;
    } else {
      key = new Date(ms + 2 * 3600000).toISOString().slice(0, 10);
    }
    return Date.parse(key + 'T00:00:00Z');
  }

  function each(list, fn) {
    for (var i = 0; i < list.length; i++) fn(list[i]);
  }

  function update() {
    var now = Date.now();
    each(document.querySelectorAll('[data-msp-end]'), function (el) {
      var end = Number(el.getAttribute('data-msp-end'));
      if (!end) return;

      if (now > end) {
        each(el.querySelectorAll('[data-msp-promo]'), function (p) { p.hidden = true; });
        each(el.querySelectorAll('[data-msp-fallback]'), function (f) { f.hidden = false; });
        if (el.hasAttribute('data-msp-promo')) el.hidden = true;
        el.classList.remove('is-msp-on');
        el.removeAttribute('data-msp-end');
        return;
      }

      var pills = el.querySelectorAll('[data-msp-days]');
      if (!pills.length) return;
      var days = Math.round((dayStart(end) - dayStart(now)) / 86400000);
      each(pills, function (pill) {
        var text = '';
        if (days >= 2) text = (pill.getAttribute('data-many') || '').replace('[days]', String(days));
        else if (days === 1) text = pill.getAttribute('data-one') || '';
        else if (days === 0) text = pill.getAttribute('data-zero') || '';
        if (text) {
          if (pill.textContent !== text) pill.textContent = text;
          pill.hidden = false;
        } else {
          pill.hidden = true;
        }
      });
    });
  }

  function start() {
    update();
    window.setInterval(update, 60000);
    document.addEventListener('shopify:section:load', update);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
